import(/* webpackMode: "eager" */ "/opt/bitnami/apache/htdocs/matco-v2-back/src/app/error.tsx");
